import { cannot } from '@/app/helpers'
import { PartTypes, SMSSurveyPart } from '@/app/module/campaigns/types'
import type { SMSSurveyCampaignDTO } from '@/app/module/campaigns/types/dtos'

import { prepareActionsOnly, prepareAPI, prepareQuotaActions, prepareSMSQuestion, SenderIdConfig } from './common'

const prepareActionsInPart = (part: SMSSurveyPart, senderIds: SenderIdConfig): SMSSurveyPart => {
  if (PartTypes.SMSMessage in part) {
    return part
  }

  if (PartTypes.SMSQuestion in part) {
    return prepareSMSQuestion(part, senderIds)
  }

  if (PartTypes.ActionsOnly in part) {
    return prepareActionsOnly(part, senderIds)
  }

  if (PartTypes.QuotaActions in part) {
    return prepareQuotaActions(part, senderIds)
  }

  if (PartTypes.ApiCall in part) {
    return prepareAPI(part, senderIds)
  }

  return cannot(part)
}

export const prepareSMSSurvey = (item: Pick<SMSSurveyCampaignDTO, 'variables'>): SMSSurveyCampaignDTO['variables'] => {
  const { senderId, senderIdQuestions } = item.variables
  const senderIds = { senderId, senderIdQuestions }

  return {
    ...item.variables,
    parts: item.variables.parts.map((part) => prepareActionsInPart(part, senderIds)),
  }
}
